<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="M3250, MS622 Yazıcılar">
     M3250, MS622 Yazıcılar
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_tr" title="G&uuml;venlik bilgileri">
     G&uuml;venlik bilgileri
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Kurallar">
      Kurallar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="&Uuml;r&uuml;n beyanları">
      &Uuml;r&uuml;n beyanları
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_tr" title="Yazıcıyı tanıma">
     Yazıcıyı tanıma
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_tr" title="Yazıcı hakkında bilgi bulma">
      Yazıcı hakkında bilgi bulma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_tr" title="Yazıcı i&ccedil;in bir yer se&ccedil;me">
      Yazıcı i&ccedil;in bir yer se&ccedil;me
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_tr" title="Yazıcı yapılandırmaları">
      Yazıcı yapılandırmaları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_tr" title="Kabloları takma">
      Kabloları takma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_tr" title="Kontrol panelini kullanarak">
      Kontrol panelini kullanarak
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_tr" title="G&uuml;&ccedil; d&uuml;ğmesinin ve g&ouml;sterge ışığının durumunu yorumlama">
      G&uuml;&ccedil; d&uuml;ğmesinin ve g&ouml;sterge ışığının durumunu yorumlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_tr" title="Ağ Ayarları Sayfasını yazdırma">
      Ağ Ayarları Sayfasını yazdırma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_tr" title="Ana ekran uygulamalarını ayarlama ve kullanma">
     Ana ekran uygulamalarını ayarlama ve kullanma
    </a>
   </p>
   <div id="divd0e748">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_tr" title="Ana ekranı kullanma">
      Ana ekranı kullanma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_tr" title="Ana ekranı &ouml;zelleştirme">
      Ana ekranı &ouml;zelleştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_tr" title="Ekran Kişiselleştirmenin Kullanılması">
      Ekran Kişiselleştirmenin Kullanılması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_tr" title="Eko Ayarları yapılandırma">
      Eko Ayarları yapılandırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_tr" title="M&uuml;şteri Desteğinin Kullanımı">
      M&uuml;şteri Desteğinin Kullanımı
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_tr" title="QR Kodu Oluşturucuyu Kullanma">
      QR Kodu Oluşturucuyu Kullanma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_tr" title="Cihaz Kotalarını Kurma">
      Cihaz Kotalarını Kurma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_tr" title="Cloud Connector profili oluşturma">
      Cloud Connector profili oluşturma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1094" title="Yer imlerini y&ouml;netme">
      Yer imlerini y&ouml;netme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1171" title="Kişileri y&ouml;netme">
      Kişileri y&ouml;netme
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_tr" title="Erişilebilirlik &ouml;zelliklerini kurma ve kullanma">
     Erişilebilirlik &ouml;zelliklerini kurma ve kullanma
    </a>
   </p>
   <div id="divd0e1290">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_tr" title="Sesli Kılavuzu Etkinleştirme">
      Sesli Kılavuzu Etkinleştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_tr" title="El hareketlerini kullanarak ekranda gezinme">
      El hareketlerini kullanarak ekranda gezinme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_tr" title="B&uuml;y&uuml;te&ccedil; modunu etkinleştirme">
      B&uuml;y&uuml;te&ccedil; modunu etkinleştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_tr" title="Sesli Kılavuz konuşma hızını ayarlama">
      Sesli Kılavuz konuşma hızını ayarlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_tr" title="Ekran klavyesini kullanma">
      Ekran klavyesini kullanma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_tr" title="S&ouml;zl&uuml; parolalar veya kişisel tanımlama numaralarını etkinleştirme">
      S&ouml;zl&uuml; parolalar veya kişisel tanımlama numaralarını etkinleştirme
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_tr" title="Kağıt ve &ouml;zel ortam y&uuml;kleme">
     Kağıt ve &ouml;zel ortam y&uuml;kleme
    </a>
   </p>
   <div id="divd0e1495">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_tr" title="Kağıt boyutunu ve t&uuml;r&uuml;n&uuml; ayarlama">
      Kağıt boyutunu ve t&uuml;r&uuml;n&uuml; ayarlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_tr" title="Universal kağıt ayarlarını yapılandırma">
      Universal kağıt ayarlarını yapılandırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_tr" title="Tepsileri y&uuml;kleme">
      Tepsileri y&uuml;kleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_tr" title="&Ccedil;ok ama&ccedil;lı besleyiciyi y&uuml;kleme">
      &Ccedil;ok ama&ccedil;lı besleyiciyi y&uuml;kleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_tr" title="Tepsileri bağlantılandırma">
      Tepsileri bağlantılandırma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_tr" title="Kağıt desteği">
     Kağıt desteği
    </a>
   </p>
   <div id="divd0e1662">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_tr" title="Desteklenen kağıt boyutları">
      Desteklenen kağıt boyutları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_tr" title="Desteklenen kağıt t&uuml;rleri">
      Desteklenen kağıt t&uuml;rleri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_tr" title="Desteklenen kağıt ağırlıkları">
      Desteklenen kağıt ağırlıkları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_tr" title="Kabul edilemez kağıtlar">
      Kabul edilemez kağıtlar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_tr" title="Geri d&ouml;n&uuml;şt&uuml;r&uuml;lm&uuml;ş kağıt kullanma">
      Geri d&ouml;n&uuml;şt&uuml;r&uuml;lm&uuml;ş kağıt kullanma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_tr" title="Yazdırma">
     Yazdırma
    </a>
   </p>
   <div id="divd0e2521">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_tr" title="Bilgisayardan yazdırma">
      Bilgisayardan yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2547" title="Mobil aygıttan yazdırma">
      Mobil aygıttan yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_tr" title="Bir flash s&uuml;r&uuml;c&uuml;den yazdırma">
      Bir flash s&uuml;r&uuml;c&uuml;den yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_tr" title="Desteklenen flash s&uuml;r&uuml;c&uuml;ler ve dosya t&uuml;rleri">
      Desteklenen flash s&uuml;r&uuml;c&uuml;ler ve dosya t&uuml;rleri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_tr" title="Gizli işlerin yapılandırılması">
      Gizli işlerin yapılandırılması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_tr" title="Gizli ve diğer bekletilen işleri yazdırma">
      Gizli ve diğer bekletilen işleri yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_tr" title="Cloud Connector profilinden yazdırma">
      Cloud Connector profilinden yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_tr" title="yazı tipi &ouml;rneği listesi yazdırma">
      yazı tipi &ouml;rneği listesi yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_tr" title="Bir dizin listesi yazdırma">
      Bir dizin listesi yazdırma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_tr" title="Bir yazdırma işini iptal etme">
      Bir yazdırma işini iptal etme
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_tr" title="Yazıcı men&uuml;lerini anlama">
     Yazıcı men&uuml;lerini anlama
    </a>
   </p>
   <div id="divd0e3057">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_tr" title="Men&uuml; haritası">
      Men&uuml; haritası
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3376" title="Aygıt">
      Aygıt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5222" title="Baskı">
      Baskı
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6480" title="Kağıt">
      Kağıt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6742" title="USB S&uuml;r&uuml;c&uuml;s&uuml;">
      USB S&uuml;r&uuml;c&uuml;s&uuml;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6963" title="Ağ/Bağlantı Noktaları">
      Ağ/Bağlantı Noktaları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8753" title="G&uuml;venlik">
      G&uuml;venlik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9888" title="Raporlar">
      Raporlar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_tr" title="Yardım">
      Yardım
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10136" title="Sorun Giderme">
      Sorun Giderme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_tr" title="Men&uuml; Ayarları Sayfasını Yazdırma">
      Men&uuml; Ayarları Sayfasını Yazdırma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_tr" title="Yazıcının g&uuml;venliğini sağlama">
     Yazıcının g&uuml;venliğini sağlama
    </a>
   </p>
   <div id="divd0e10188">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_tr" title="G&uuml;venlik yuvasının konumlandırılması">
      G&uuml;venlik yuvasının konumlandırılması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_tr" title="Yazıcı belleğini silme">
      Yazıcı belleğini silme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_tr" title="Yazıcı sabit diski belleğini silme">
      Yazıcı sabit diski belleğini silme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_tr" title="Yazıcının sabit diskini şifreleme">
      Yazıcının sabit diskini şifreleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_tr" title="&Uuml;retici varsayılan ayarlarını geri y&uuml;kleme">
      &Uuml;retici varsayılan ayarlarını geri y&uuml;kleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_tr" title="Ge&ccedil;icilik Bildirimi">
      Ge&ccedil;icilik Bildirimi
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_tr" title="Yazıcının bakımını yapma">
     Yazıcının bakımını yapma
    </a>
   </p>
   <div id="divd0e10402">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_tr" title="E-posta uyarılarını ayarlama">
      E-posta uyarılarını ayarlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_tr" title="Varsayılan kulaklık ses d&uuml;zeyini ayarlama">
      Varsayılan kulaklık ses d&uuml;zeyini ayarlama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10464" title="Ağ Oluşturma">
      Ağ Oluşturma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_tr" title="Seri yazdırmayı kurma (yalnızca Windows)">
      Seri yazdırmayı kurma (yalnızca Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_tr" title="Yazıcıyı temizleme">
      Yazıcıyı temizleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_tr" title="Par&ccedil;a ve sarf malzemeleri sipariş etme">
      Par&ccedil;a ve sarf malzemeleri sipariş etme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11200" title="Par&ccedil;a ve sarf malzemeleri değiştirme">
      Par&ccedil;a ve sarf malzemeleri değiştirme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11344" title="Yazıcıyı taşıma">
      Yazıcıyı taşıma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11400" title="Enerji ve kağıt tasarrufu">
      Enerji ve kağıt tasarrufu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11504" title="Geri d&ouml;n&uuml;şt&uuml;rme">
      Geri d&ouml;n&uuml;şt&uuml;rme
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_tr" title="Sıkışmaları giderme">
     Sıkışmaları giderme
    </a>
   </p>
   <div id="divd0e11537">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_tr" title="Sıkışmaları &ouml;nleme">
      Sıkışmaları &ouml;nleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_tr" title="Sıkışma konumlarını belirleme">
      Sıkışma konumlarını belirleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_tr" title="A kapağında kağıt sıkışması">
      A kapağında kağıt sıkışması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_tr" title="Arka kapakta kağıt sıkışması">
      Arka kapakta kağıt sıkışması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_tr" title="Standart selede kağıt sıkışması">
      Standart selede kağıt sıkışması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_tr" title="&Ouml;nl&uuml; arkalı &uuml;nitesinde kağıt sıkışması">
      &Ouml;nl&uuml; arkalı &uuml;nitesinde kağıt sıkışması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_tr" title="Tepsilerde kağıt sıkışması">
      Tepsilerde kağıt sıkışması
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_tr" title="&Ccedil;ok ama&ccedil;lı besleyicide kağıt sıkışması">
      &Ccedil;ok ama&ccedil;lı besleyicide kağıt sıkışması
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_tr" title="Sorun Giderme">
     Sorun Giderme
    </a>
   </p>
   <div id="divd0e11813">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11816" title="Ağ bağlantısı sorunları">
      Ağ bağlantısı sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12130" title="Donanım se&ccedil;enekleri sorunları">
      Donanım se&ccedil;enekleri sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12404" title="Sarf malzemeleriyle ilgili sorunlar">
      Sarf malzemeleriyle ilgili sorunlar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_tr" title="Kağıt besleme sorunları">
      Kağıt besleme sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_tr" title="Yazdırma sorunları">
      Yazdırma sorunları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_tr" title="M&uuml;şteri destek merkezine başvurma">
      M&uuml;şteri destek merkezine başvurma
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_tr" title="Y&uuml;kseltme ve ge&ccedil;iş">
     Y&uuml;kseltme ve ge&ccedil;iş
    </a>
   </p>
   <div id="divd0e15396">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15399" title="Donanım">
      Donanım
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15709" title="Yazılım">
      Yazılım
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15792" title="Bellenim">
      Bellenim
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_tr" title="Bildirimler">
     Bildirimler
    </a>
   </p>
   <div id="divd0e15879">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15882" title="&Uuml;r&uuml;n bilgileri">
      &Uuml;r&uuml;n bilgileri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15899" title="S&uuml;r&uuml;m bildirimi">
      S&uuml;r&uuml;m bildirimi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_tr" title="Ticari markalar">
      Ticari markalar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_tr" title="Lisans uyarıları">
      Lisans uyarıları
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_tr" title="Ses emisyon seviyeleri">
      Ses emisyon seviyeleri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_tr" title="Atık Elektrik ve Elektronik Cihazlar (WEEE) direktifi">
      Atık Elektrik ve Elektronik Cihazlar (WEEE) direktifi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16003" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_tr" title="&Uuml;r&uuml;n&uuml; elden &ccedil;ıkarma">
      &Uuml;r&uuml;n&uuml; elden &ccedil;ıkarma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16037" title="Laddningsbart litiumjonbatteri">
      Laddningsbart litiumjonbatteri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sv" title="F&ouml;rordning (EU) 2023/1542">
      F&ouml;rordning (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sv" title="L&auml;mna tillbaka Lexmark-kassetter f&ouml;r &aring;teranv&auml;ndning eller &aring;tervinning">
      L&auml;mna tillbaka Lexmark-kassetter f&ouml;r &aring;teranv&auml;ndning eller &aring;tervinning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_tr" title="Statik elektriğe duyarlılık uyarısı">
      Statik elektriğe duyarlılık uyarısı
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_tr" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_tr" title="Sıcaklık bilgileri">
      Sıcaklık bilgileri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_tr" title="Lazer uyarısı">
      Lazer uyarısı
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_tr" title="G&uuml;&ccedil; t&uuml;ketimi">
      G&uuml;&ccedil; t&uuml;ketimi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16277" title="Kablosuz &uuml;r&uuml;nler i&ccedil;in d&uuml;zenleyici bildirimler">
      Kablosuz &uuml;r&uuml;nler i&ccedil;in d&uuml;zenleyici bildirimler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_tr" title="Mod&uuml;ler bileşen bildirimi">
      Mod&uuml;ler bileşen bildirimi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_tr" title="Radyo frekans radyasyonuna maruz kalma">
      Radyo frekans radyasyonuna maruz kalma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16303" title="Avrupa Topluluğu (AT) y&ouml;nergelerine uygunluk">
      Avrupa Topluluğu (AT) y&ouml;nergelerine uygunluk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_tr" title="Avrupa Topluluğu (AT) y&ouml;nergelerine uygunluk">
      Avrupa Topluluğu (AT) y&ouml;nergelerine uygunluk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_tr" title="Radyo paraziti uyarısı">
      Radyo paraziti uyarısı
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue